import * as React from "react";

import { VisuallyHidden } from "@radix-ui/themes";
import {
  useCurrentRefinements,
} from "react-instantsearch";

import { useMediaQuery } from "@/shared-web.ui/hook.use-media-query";
import { PrimDrawer } from "@/shared-web.ui/prim.drawer";
import { PrimSheet } from "@/shared-web.ui/prim.sheet";
import { Badge } from "@/shared-web.ui/ui.badge";
import { Separator } from "@/shared-web.ui/ui.separator";
import { PrimProductTuneButton } from "@/stf.ui/prim.product-tune-button";

import { ProductFacetContext, useProductFacetContext } from "./context";
import { ProductFacetContent } from "./core-facet";

const FilterMobile = () => {
  const {
    filterCount,
  } = useProductFacetContext();

  return (
    <PrimDrawer.Root>
      <PrimDrawer.Trigger asChild>
        <PrimProductTuneButton.FilterTrigger>
          <PrimProductTuneButton.FilterTriggerText>
            Filters
          </PrimProductTuneButton.FilterTriggerText>
          {filterCount > 0 && (
            <>
              <Separator mx="1" orientation="vertical" />
              <Badge>
                {filterCount}
              </Badge>
            </>
          )}
        </PrimProductTuneButton.FilterTrigger>
      </PrimDrawer.Trigger>
      <PrimDrawer.Content
        className="h-[90%]"
        forceMount
        aria-describedby={undefined}
      >
        <VisuallyHidden>
          <PrimDrawer.Title>Product Facet</PrimDrawer.Title>
        </VisuallyHidden>
        <ProductFacetContent
          className="p-4 pt-0"
        />
      </PrimDrawer.Content>
    </PrimDrawer.Root>
  );
};

const FilterDesktop = () => {
  const { filterCount } = useProductFacetContext();

  return (
    <PrimSheet.Root>
      <PrimSheet.Trigger asChild>
        <PrimProductTuneButton.FilterTrigger>
          <PrimProductTuneButton.FilterTriggerText>
            Filters
          </PrimProductTuneButton.FilterTriggerText>
          {filterCount > 0 && (
            <>
              <Separator mx="1" orientation="vertical" />
              <Badge>
                {filterCount}
              </Badge>
            </>
          )}
        </PrimProductTuneButton.FilterTrigger>
      </PrimSheet.Trigger>
      <PrimSheet.Content
        side="right"
        aria-describedby={undefined}
      >
        <VisuallyHidden>
          <PrimSheet.Title>Product Facet</PrimSheet.Title>
        </VisuallyHidden>
        <ProductFacetContent />
      </PrimSheet.Content>
    </PrimSheet.Root>
  );
};

const ProductFacet = () => {
  const usePopover = useMediaQuery({
    size: "xs",
    type: "min-width",
  });

  const { items } = useCurrentRefinements();

  const filterCount = React.useMemo(() => {
    return items.reduce((acc, cur) => {
      if (!cur.attribute.match(/categoryHierarchySlug\./u)) {
        return acc + cur.refinements.length;
      }
      return acc;
    }, 0);
  }, [items]);

  return (
    <ProductFacetContext.Provider
      value={{
        filterCount,
      }}
    >
      {usePopover
        ? (
            <FilterDesktop />
          )
        : (
            <FilterMobile />
          )}
    </ProductFacetContext.Provider>
  );
};

export {
  ProductFacet,
  ProductFacetContent,
};
